/*******************************************************************************
GET FILTER SETTINGS
Get the settings for the main filter.
*******************************************************************************/

export default function getFilterSettings(tabSetName) {
    const $tabs = $(`.filter-tabs[data-name="${tabSetName}"]`);

    return {
        // The selector that matches all the items we're filtering on
        items: `${$tabs.data('items')}:not(.filter-tab-empty)`,

        // The name of the tab set
        name: tabSetName,

        // This optional attribute is used if the content that needs to be searched is something specific inside the item
        // Ex. If an item is a table row, but you only want to filter the results based on the first column's content
        subset: $tabs.data('subset') || '',

        // This is a selector that identifies the element whose text gets replaced with a tab's title data attribute value
        // It's mostly useful for changing the title of a section based on which filter tab is selected
        titleTarget: $tabs.data('title-target') || '',
    };
}
